export const namedPaths = {
  home: '/Pokedux',
  favourites: '/Pokedux/favourites',
};
